import { findIndex, find } from 'lodash';
import { usePage } from './use-page';
import { LinearNavigationContext } from '../components/context/linear-navigation-context';
import { useContext, useMemo } from 'react';
var emptyInfo = {
  items: [],
  hasNext: false,
  hasPrev: false
};
export var useLinearNavigation = function useLinearNavigation() {
  var items = useContext(LinearNavigationContext) || [];
  var page = usePage();

  if (!(items && items.length && page)) {
    return emptyInfo;
  }

  return useMemo(function () {
    // the value here needs to be the actual option object (could we abstract over this and look for the value??)
    var selectedIndex = findIndex(items, function (item) {
      return item.path === page.path;
    });
    var current = find(items, function (item) {
      return item.path === page.path;
    });
    var next = selectedIndex !== -1 ? selectedIndex < items.length - 1 ? items[selectedIndex + 1] : null : null;
    var prev = selectedIndex > 0 ? items[selectedIndex - 1] : null;
    var hasNext = !!next;
    var hasPrev = !!prev;
    var ret = {
      items: items,
      current: current,
      next: next,
      prev: prev,
      hasNext: hasNext,
      hasPrev: hasPrev
    };

    if (process.env.DEBUG_LINEAR_NAVIGATION === "true") {
      console.log(ret);
    }

    return ret;
  }, [page, items]);
};